import { IListStudent } from "../../types/request_data/students";
export const studentJSON = {
  listStudent: ({
    pageNo,
    limit,
    sortKey,
    sortOrder,
    searchTerm,
    className,
    school,
    subjects,
  }: IListStudent) => {
    let data: any = {
      pageNo: pageNo,
      limit: limit,
      sortKey: sortKey,
      sortOrder: sortOrder,
      needCount: true,
      searchTerm: searchTerm,
      class: className,
      schoolReference: school,
    };
    if (subjects) {
      subjects.forEach((item: any, index: number) => {
        data = { ...data, [`subjects[${index}]`]: item.value };
      });
    }
    return data;
    // return {
    //   pageNo: pageNo,
    //   limit: limit,
    //   sortKey: sortKey,
    //   sortOrder: sortOrder,
    //   needCount: pageNo === 1 ? true : false,
    //   searchTerm: searchTerm,
    //   class: className,
    //   schoolReference: school,
    // };
  },
};
